/**
 * This module manages browser and mobile state locally (no API)
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 * @todo I need to visit this to make it dispatch like the others. --BL
 */

import {
	VUEX_GLOBAL_SET_MOBILE_STATE,
	VUEX_GLOBAL_SET_MOBILE_DEVICE,
	VUEX_GLOBAL_SET_BROWSER_STATE,
	VUEX_GLOBAL_SET_BROWSER_NAME,
	VUEX_GLOBAL_SET_BROWSER_VERSION,
	VUEX_GLOBAL_SET_BROWSER_BLOCKED
} from '@/store/constants/mobile'

const state = {
	mobile: null,
	isMobileDevice: false,
	browser: {
		name: null,
		version: null,
		blocked: null,
		features: {
			grid: null
		},
	}
}

const getters = {}

const actions = {
	[VUEX_GLOBAL_SET_MOBILE_STATE]: ({ commit }, payload) => {
		commit(VUEX_GLOBAL_SET_MOBILE_STATE, payload)
	},

	[VUEX_GLOBAL_SET_MOBILE_DEVICE]: ({commit}, payload) => {
		commit(VUEX_GLOBAL_SET_MOBILE_DEVICE)
	},

	[VUEX_GLOBAL_SET_BROWSER_STATE]: ({ commit }, payload) => {
		commit(VUEX_GLOBAL_SET_BROWSER_STATE, payload)
	},

	[VUEX_GLOBAL_SET_BROWSER_NAME]: ({ commit }, payload) => {
		commit(VUEX_GLOBAL_SET_BROWSER_NAME, payload)
	},

	[VUEX_GLOBAL_SET_BROWSER_VERSION]: ({ commit }, payload) => {
		commit(VUEX_GLOBAL_SET_BROWSER_VERSION, payload)
	},

	[VUEX_GLOBAL_SET_BROWSER_BLOCKED]: ({ commit }, payload) => {
		commit(VUEX_GLOBAL_SET_BROWSER_BLOCKED, payload)
	},
	// Added this style of action to match the other modules but does the same as setMobileState
}

const mutations = {
	[VUEX_GLOBAL_SET_MOBILE_STATE]: (state, payload) => {
		state.mobile = payload
	},

	[VUEX_GLOBAL_SET_MOBILE_DEVICE]: (state, payload) => {
		state.isMobileDevice = payload
	},

	[VUEX_GLOBAL_SET_BROWSER_STATE]: (state, payload) => {
		state.browser = payload
	},

	[VUEX_GLOBAL_SET_BROWSER_VERSION]: (state, payload) => {
		state.browser.name = payload
	},

	GLOBAL_SET_BROWSER_VERSION: (state, payload) => {
		state.browser.version = payload
	},

	[VUEX_GLOBAL_SET_BROWSER_BLOCKED]: (state, payload) => {
		state.browser.blocked = payload
	}
}

/**
 * The Mobile module of our Vuex store.
 * @module store/modules/mobile
 */
export default {
  state,
  getters,
  actions,
  mutations,
}
